import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";

import { apiEndPoints } from "../variables/apiEndpoints";
import { TransactionDataType } from "../types/genericType";

export const createReconcile = async (
  id: number,
): Promise<TransactionDataType[]> => {
  try {
    const response: AxiosResponse<TransactionDataType[]> =
      await axiosInstance.post(`${apiEndPoints.transactions}/${id}/reconcile`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createUnReconcile = async (
  id: number,
): Promise<TransactionDataType[]> => {
  try {
    const response: AxiosResponse<TransactionDataType[]> =
      await axiosInstance.post(`${apiEndPoints.transactions}/${id}/unreconcile`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};
